import { AdhaUaePassCallbackScreen } from '@/modules/auth/components/AdhaUaePassCallbackScreen';
import { Stack } from 'expo-router';
import React from 'react';

/**
 * Native ADHA UAE Pass OAuth WebView.
 * Web continues to use `uae-pass.web.tsx` (unchanged).
 */
export default function AdhaUaePassCallbackRoute() {
  return (
    <>
      {/* iOS swipe-back would otherwise pop straight to whatever's under this
          screen in the native stack (e.g. Welcome), skipping goToLogin()'s
          cleanup (clearing OAuth state, in-flight login tracking, etc.) —
          same reasoning as Home's gestureEnabled:false. */}
      <Stack.Screen options={{ gestureEnabled: false }} />
      <AdhaUaePassCallbackScreen />
    </>
  );
}
